// Customer domain values mapped to Pill tones. A backend rename or a new
// status changes this file and nothing else visual.

export const customerStatusTone = {
  ACTIVE: 'ok',
  DORMANT: 'neutral',
  LOST: 'bad',
}
